// AuraVeil — Section 5 Generation Specs (LOCKED)
// This file is the brand contract for ALL AI card artwork generation.
// Do not loosen these values without a product decision.
// Backend mirror: /app/backend/deck_settings.py — keep both in sync.

export const GOLDEN_LIGHT = "#D4AF37"; // primary gold accent (Founder gold)
export const MATTE_BLACK = "#080808"; // app + artwork base

export const DECK_SETTINGS = Object.freeze({
  palette: Object.freeze({
    name: "Golden Light",
    gold: GOLDEN_LIGHT,
    black: MATTE_BLACK,
    finish: "matte", // matte texture only — no gloss, no lens flare, no plastic sheen
  }),
  generation: Object.freeze({
    // All AI image calls MUST exclude text of any kind
    excludeText: true,
    // One canvas per deck, cropped into cards — never per-card generation calls
    singleCanvasGrid: true,
    grid: Object.freeze({ rows: 2, cols: 3, cards: 6 }),
    cardAspect: "1:1", // matches House card backs exactly
    cardTargetPx: 900,
    // Card faces must match the House card backs: gold-on-black ceremonial scheme
    scheme: "gold-on-black",
    texture: "matte ceremonial illustration",
  }),
});
